module.exports = __webpack_public_path__ + "img/5G-02-01.acc8d5e0.png";